import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { ISimulationPayload } from '../Simulation.ts';
import { SimulationApi } from '../../../apis/SimulationApi/SimulationApi.ts';

type UpdateSimulationInput = {
    entityId: string;
    data: ISimulationPayload;
};

export function usePutSimulationMutations() {
    return useMutation<number, AppMedError, UpdateSimulationInput>({
        mutationKey: [QueryKeys.simulation],
        mutationFn: async ({ entityId, data }) => {
            await SimulationApi.putSimulation(entityId, data);
            return Number(entityId);
        },
    });
}
